const config={
    URL:'https://api.onegml.com/v1/web/register',
    URL_2:'https://api.onegml.com/v1',
    //URL:'https://testexapi.onegml.com/v1/web/register',
    //URL_2:'https://testexapi.onegml.com/v1',
    //URL:'http://localhost:5000/v1/web/register',
    //URL_2:'http://localhost:5000/v1',
    USER:'onegmlapi',
    PASS:'O1n6e0G4M7L',
    TRACKING_ID:'UA-179707657-1'
}

export const {URL,USER,PASS,URL_2,TRACKING_ID}=config